<header>
  <mat-toolbar color="primary" class="mat-toolbar mat-primary mat-toolbar-single-row">
    @if (!isLoggedOut) {
      <button mat-icon-button id="homeButton" (click)="onHomeClick()" routerLink="dashboard" routerLinkActive="active" class="mat-focus-indicator icons mat-icon-button mat-button-base mat-button-home" aria-label="Home">
        <span class="mat-button-wrapper">
          <mat-icon  role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">home</mat-icon>
        </span>
        <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    }
    <span id="env" class="display-tag mode">{{envName}}</span>
    <span class="app-toolbar-filler"></span>
    @if (!isLoggedOut) {
      <span id="user" class="display-tag">{{clientUser}}</span>
    }
    <div id="logo" role="img" aria-label="Progressive Small Business"></div>
    @if (!isLoggedOut) {
      <button mat-icon-button id="logoutButton" (click)="onLogoutClick()" class="mat-focus-indicator icons mat-icon-button mat-button-base mat-button-logout" aria-label="Logout">
        <span class="mat-button-wrapper">
          <mat-icon  role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">exit_to_app</mat-icon>
        </span>
        <span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    }
  </mat-toolbar>
</header>